export default __webpack_public_path__ + "static/media/005-mangosteen.799783cf.svg";